<script setup lang="ts">
import { AppTheme } from '~/types'

defineProps<{
  data: FileField
  idx: number
  layout: 'grid' | 'collage' | 'slider'
}>()

const store = useAppStore()
const imageFormats = ['jpg', 'png', 'webp', 'svg', 'gif']
const videoFormats = ['mp4', 'webm', 'ogg']

const mediaImageRef = ref<HTMLImageElement | null>(null)

defineExpose({
  mediaImageRef
})
</script>

<template>
  <template v-if="imageFormats.includes(data.format)">
    <Image
      ref="mediaImageRef"
      loading="lazy"
      :class="{
        'w-full': layout === 'grid' || layout === 'collage',
        'aspect-video w-full max-w-none object-cover': layout === 'slider'
      }"
      :src="data.url"
      :srcset="data.responsiveImage ? data.responsiveImage?.webpSrcSet : undefined"
      :width="data.width ?? 400"
      :height="data.height ?? 400"
      :alt="data.alt ?? ''"
    />
  </template>
  <template v-else-if="videoFormats.includes(data.format)">
    <VideoLoop
      :class="{
        'w-full': layout === 'grid',
        'w-auto': layout === 'collage',
        'aspect-video w-full object-cover': layout === 'slider'
      }"
      :sources="[{ type: 'video/mp4', src: data.video?.mp4Url }]"
      :width="data.width ?? 400"
      :height="data.height ?? 400"
    />
  </template>
  <div
    v-if="data.title || data.customData"
    class="mt-2.5 text-sm lg:mt-3 lg:px-0"
    :class="store.theme === AppTheme.DARK ? 'text-white opacity-40' : 'text-black'"
  >
    <div v-if="data.title">{{ data.title }}</div>
    <div v-if="data.customData">
      <div v-for="(item, jdx) in Object.values(data.customData)" :key="jdx">
        {{ item }}
      </div>
    </div>
  </div>
</template>
